/**
 * 時間前市場 コマ取引状態一覧 (48 コマ分) 取得 hook。
 */
import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listBiddingMarketProducts } from '@ebalance/proto/bffuser/v1/bidding_intraday_market_service-BiddingIntradayMarketService_connectquery'
import {
  ListBiddingMarketProductsRequestSchema,
  type ListBiddingMarketProductsResponse,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_market_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { UseQueryResult } from '@tanstack/react-query'

// NotifyMarket にコマ取引状態 (SuspenseCode) の変化を知らせる event が無いため取り直す。
const MARKET_PRODUCTS_REFRESH_INTERVAL_MS = 30_000

export function useMarketProducts(
  deliveryDate: ProtoDate | undefined,
  enabled: boolean,
  autoRefresh = false,
): UseQueryResult<ListBiddingMarketProductsResponse, ConnectError> {
  return useQuery(
    listBiddingMarketProducts,
    create(ListBiddingMarketProductsRequestSchema, {
      deliveryDate,
    }),
    {
      enabled: enabled && deliveryDate !== undefined,
      staleTime: Infinity,
      // backend gRPC 未接続でも error boundary に飛ばさず、 呼び出し側でローディング表示。
      throwOnError: false,
      refetchInterval: (query) =>
        query.state.status === 'error'
          ? 5000
          : autoRefresh
            ? MARKET_PRODUCTS_REFRESH_INTERVAL_MS
            : false,
    },
  )
}
